import { formatDateHuman } from "../date-utils";
import { dossierExpiringDescription } from "../misc/dossier-expiring-description";
export const dashboardExpiringDossierDtoFields = [{
        name: "protocol",
        title: "Protocollo",
        render: (record) => record.dossier.protocol
    }, {
        name: "customerName",
        title: "Cliente"
    }, {
        name: "dossierTypeDescription",
        title: "Causale Pratica"
    }, {
        name: "title",
        title: "Descrizione aggiuntiva",
        render: (record) => record.dossier.title
    }, {
        name: "deadlineDate",
        title: "Scadenza",
        render: (record) => {
            let formattedDate = formatDateHuman(record.dossier.deadlineDate);
            if (record.finalStatus == 0) {
                return dossierExpiringDescription(record.dossier, formattedDate);
            }
            return formattedDate;
        }
    }];
